var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerecederosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4437 15.3901C17.6376 22.3518 10.9153 18.1402 10.9153 18.1402C8.85274 22.306 5.44573 24.9847 1.51418 25C0.694253 25 0.66879 23.7574 1.51418 23.7574C4.79387 23.7421 7.65086 21.5828 9.51988 18.1503C7.42678 18.9601 3.47995 19.5712 1.2901 13.9641C6.84113 11.6775 9.39256 14.5345 10.3704 16.2813C10.8745 15.0387 11.2361 13.6891 11.4704 12.2224C11.4704 12.2224 4.35589 13.3377 3.85681 7.22652C9.9222 4.78713 11.6283 11.1326 11.6283 11.1326C11.7097 10.2821 11.7963 8.45386 11.7963 8.41312C11.7963 8.41312 6.38278 4.65981 9.856 0C16.2015 2.18986 12.9829 8.27052 12.9829 8.27052C13.0084 8.35201 13.0084 9.48258 12.9829 9.97148C12.9829 9.97148 15.2848 5.43899 19.9293 7.04319C19.7154 13.8674 12.7028 12.4618 12.7028 12.4618C12.4787 13.8572 12.1324 15.1813 11.6843 16.4086C11.6843 16.4086 15.9112 11.7336 20.4437 15.3901Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerecederosIcon);
export default __webpack_public_path__ + "static/media/perecederos_icon.739fd0babcc735863584c80319020679.svg";
export { ForwardRef as ReactComponent };